import React from "react";
import {useNavigate} from 'react-router-dom'

function Navbar() {
    const navigate = useNavigate()
    return (
        <div className="bg-white box-border drop-shadow-lg flex flex-row h-[10vh] w-full items-center justify-between px-10 text-xl fixed top-0 left-0 right-0 z-10">
            <div className="flex flex-row gap-3 items-center justify-center cursor-pointer" onClick={() => {
                navigate('/')
            }}>
                <img src="/logo-clover.png" className="w-8 h-8" alt='' />
                <div className="font-bold">CLOVER</div>
            </div>
            <div className="flex flex-row w-5 gap-8 items-center justify-center">
                <div className="cursor-pointer">Men</div>
                <div className="cursor-pointer">Women</div>
                <div className="cursor-pointer">Kids</div>
                <div className="cursor-pointer">Customise</div>
                <div className="cursor-pointer">Sale</div>
                <div className="cursor-pointer">SNKRS</div>
            </div>
            <div className="flex flex-row gap-5 items-center justify-center text-lg">
                <input type="text" className="focus:outline-none pl-4 h-8 rounded-md bg-gray-100 text-sm" placeholder="Search" />
                <div className="flex items-center justify-center">
                    <span className="material-symbols-outlined cursor-pointer">favorite</span>
                </div>
                <div className="flex items-center justify-center">
                    <span className="material-symbols-outlined cursor-pointer">shopping_bag</span>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
